class DrmError extends Error {
    private msg: string;
    private detail: unknown | null;

    constructor(msg: string, detail: unknown|null) {
        super('DRM load error');

        this.msg = msg;
        this.detail = detail;
    }
}

export default DrmError;